function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { classnames } from '@bydesign-ui/utils';
import { useCarousel, useSlideTo } from '../../hooks/carousel';
import React, { Children, cloneElement, useCallback, useEffect, useState } from 'react';
import { usePrefixCls } from '@byte-design/config';
export var CarouselPagination = function CarouselPagination(props) {
  var children = props.children,
      className = props.className,
      extra = _objectWithoutProperties(props, ["children", "className"]);

  var carousel = useCarousel();
  var handleSlideTo = useSlideTo();
  var speed = carousel.speed,
      sliders = carousel.sliders,
      autoplay = carousel.autoplay,
      currentIndex = carousel.currentIndex,
      paginationType = carousel.paginationType,
      paginationColor = carousel.paginationColor,
      paginationPosition = carousel.paginationPosition,
      paginationActiveColor = carousel.paginationActiveColor;

  var _useState = useState(currentIndex),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var carouselDotsCls = classnames(usePrefixCls('carousel-pagination', _defineProperty({}, paginationPosition, true)), className);
  var sliderCount = carousel.effect === 'slide' ? sliders.length - 2 : sliders.length;
  var handleActiveIndexChange = useCallback(function (index) {
    setActiveIndex(index);
  }, []);

  var renderPagination = function renderPagination() {
    return Children.map(new Array(sliderCount), function (item, index) {
      var _usePrefixCls2;

      var isActive = activeIndex === index;
      var paginationStyle = {
        backgroundColor: paginationColor,
        backgroundImage: isActive ? "linear-gradient(".concat(paginationActiveColor, ",").concat(paginationActiveColor, ")") : 'none'
      };

      if (paginationType === 'progress') {
        Object.assign(paginationStyle, {
          animationDuration: isActive && autoplay ? "".concat(speed / 1000, "s") : '0',
          animationPlayState: autoplay ? 'running' : 'paused'
        });
      }

      return React.createElement("li", {
        key: index,
        className: usePrefixCls('carousel-pagination-item', (_usePrefixCls2 = {}, _defineProperty(_usePrefixCls2, paginationType, true), _defineProperty(_usePrefixCls2, "".concat(paginationType, "-active"), isActive), _usePrefixCls2)),
        style: paginationStyle,
        onClick: function onClick() {
          return handleSlideTo(index);
        }
      });
    });
  };

  useEffect(function () {
    carousel.addListener('active-index-change', handleActiveIndexChange);
    return function () {
      carousel.removeListener('active-index-change', handleActiveIndexChange);
    };
  }, []);

  if (children && Children.count(children) !== sliderCount) {
    throw Error("pagination's count is not equal to the sliders");
  }

  if (sliderCount <= 1 || children && Children.count(children) <= 1) {
    return null;
  }

  return React.createElement("div", Object.assign({}, extra, {
    className: carouselDotsCls
  }), children ? Children.map(children, function (item, index) {
    return cloneElement(item, {
      onClick: function onClick() {
        return handleSlideTo(index);
      }
    });
  }) : renderPagination());
};